import { createSelector, MemoizedSelector } from '@ngrx/store';
import { ProductRecommendationEntity } from '@product/const/v2';
import { StateUtils } from '@spartacus/core';
import { ProductRecommendationsState, StateWithProductRecommendations } from '../product-recommendations-state';
import { getFeatureState } from './feature.selectors';

export const getProductRecommendationState: MemoizedSelector<
  StateWithProductRecommendations,
  StateUtils.LoaderState<ProductRecommendationEntity[]>
> = createSelector(getFeatureState, (state: ProductRecommendationsState) => state.productRecommendation);

export const getProductRecommendationValue: MemoizedSelector<
  StateWithProductRecommendations,
  ProductRecommendationEntity[]
> = createSelector(
  getProductRecommendationState,
  (state: StateUtils.LoaderState<ProductRecommendationEntity[]>) => StateUtils.loaderValueSelector(state) ?? [],
);

export const getProductRecommendationLoading: MemoizedSelector<StateWithProductRecommendations, boolean> =
  createSelector(getProductRecommendationState, (state: StateUtils.LoaderState<ProductRecommendationEntity[]>) =>
    StateUtils.loaderLoadingSelector(state),
  );

export const getProductRecommendationError: MemoizedSelector<StateWithProductRecommendations, boolean> = createSelector(
  getProductRecommendationState,
  (state: StateUtils.LoaderState<ProductRecommendationEntity[]>) => StateUtils.loaderErrorSelector(state),
);

export const getProductRecommendationSuccess: MemoizedSelector<StateWithProductRecommendations, boolean> =
  createSelector(getProductRecommendationState, (state: StateUtils.LoaderState<ProductRecommendationEntity[]>) =>
    StateUtils.loaderSuccessSelector(state),
  );
